import { createSelector } from 'reselect'
import { AppState } from 'Store'
import { BikSuggestModel } from 'Modules'

const getAll = (state: AppState) => state.modules.notificationList.notifications.entries
const getTotal = (state: AppState) => state.modules.notificationList.notifications.total_entries
const getCurrentRequestParams = (state: AppState) => state.modules.notificationList.requestParams
const getMessage = (state: AppState) => state.modules.notificationList.message
const getStats = (state: AppState) => state.modules.notificationList.stats
const getTotalAll = (state: AppState) => state.modules.notificationList.stats?.all?.total
const getTotalAllRead = (state: AppState) => state.modules.notificationList.stats?.unreaded?.total
const getGroup = (state: AppState) => state.modules.notificationList.group
const getVisibleDrawer = (state: AppState) => state.modules.notificationList.isVisibleDrawer

const getBik = (state: AppState) => state.modules.notificationList.bik

const getSelectBik = createSelector(getBik, (biks) =>
	biks.map(
		(bik): BikSuggestModel => ({
			...bik,
			key: `${bik.bic} (${bik.name})`,
		})
	)
)

export const notificationListSelector = {
	getAll,
	getTotal,
	getCurrentRequestParams,
	getStats,
	getMessage,
	getTotalAll,
	getTotalAllRead,
	getGroup,
	getVisibleDrawer,
	getBik,
	getSelectBik,
}
